((CurrencyWidget, $) => {
  'use strict';

  const arrowRotateClass = 'currency-arrow-rotate';
  const mobileActiveClass = 'mobile-options-item-active';
  const desktopActiveTogglerClass = 'desktop-currency-display-text-wrapper-active';
  const desktopActiveItemClass = 'desktop-options-item-active';
  const globalActiveItemClass = 'currency-item-active';

  let $mobileNav;
  let $mobileToggle;
  let $mobileCurrencyList;
  let $mobileItem;
  let $desktopCurrencyWrapper;
  let $desktopCurrencyToggle;
  let $desktopCurrencyItem;
  let $desktopCurrencyDisplayText;
  let $currencyArrow;
  let $currencyItem;
  let $window;

  const cacheDom = () => {
    $mobileNav = $('.js-mobile-nav-dropdown');
    $mobileToggle = $mobileNav.find('.js-mobile-currency-toggle');
    $mobileCurrencyList = $mobileNav.find('.js-mobile-currency-list');
    $mobileItem = $mobileNav.find('.js-mobile-currency-item');

    $desktopCurrencyWrapper = $('.js-desktop-currency-wrapper');
    $desktopCurrencyToggle = $desktopCurrencyWrapper.find('.js-desktop-currency-toggle');
    $desktopCurrencyItem = $desktopCurrencyWrapper.find('.js-desktop-currency-item');
    $desktopCurrencyDisplayText = $desktopCurrencyWrapper.find('.js-desktop-currency-display-text');

    $currencyArrow = $('.js-currency-arrow');
    $currencyItem = $('[data-currency-item]');
    $window = $(window);
  };

  const arrowToggle = (self) => {
    const $arrow = $(self).find($currencyArrow);

    if ($arrow.hasClass(arrowRotateClass)) {
      $arrow.removeClass(arrowRotateClass);
    } else {
      $arrow.addClass(arrowRotateClass);
    }
  };

  const desktopActiveToggle = () => {
    if ($desktopCurrencyToggle.hasClass(desktopActiveTogglerClass)) {
      $desktopCurrencyToggle.removeClass(desktopActiveTogglerClass);
    } else {
      $desktopCurrencyToggle.addClass(desktopActiveTogglerClass);
    }
  };

  const desktopToggle = (self) => {
    arrowToggle(self);
    desktopActiveToggle();
  };

  const getCurrency = () => {
    return window.Geolizr.cookie('geolizr-currency') || 'USD';
  };

  const setActiveClass = ($this, localActiveClass, globalActiveItemClass, currency) => {
    if ($this.data('currency').toLowerCase() === currency.toLowerCase()) {
      $this.addClass(localActiveClass).addClass(globalActiveItemClass);
    }
  };

  const initialCurrencyView = () => {
    const currency = getCurrency();

    $desktopCurrencyDisplayText.text(currency);

    $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
    $mobileItem.each(function setActiveCurrencyMobile() {
      setActiveClass($(this), mobileActiveClass, globalActiveItemClass, currency);
    });

    $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
    $desktopCurrencyItem.each(function setActiveCurrencyDesktop() {
      setActiveClass($(this), desktopActiveItemClass, globalActiveItemClass, currency);
    });
  };

  const removeCurrencyWidget = () => {
    const listID = 'geolizr-currency-list';
    const listSwitcher = 'geolizr-currency-switcher';

    $(`#${listID}`).remove();
    $(`#${listSwitcher}`).remove();
  };

  const setCurrency = (currency) => {
    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      window.GeolizrAPI.api.switchCurrency(currency);
    }
  };

  const clickBind = () => {
    /* MOBILE SPECIFIC */
    $mobileToggle.on('click', function toggleCurrencyListMobile() {
      if ($('.js-mobile-language-list').is(':visible')) {
        $('.js-mobile-language-list').slideToggle();
      }
      $mobileCurrencyList.slideToggle();
      arrowToggle(this);
    });

    $mobileItem.on('click', function setActiveMobile() {
      if (!$(this).hasClass(mobileActiveClass)) {
        $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
        $(this).addClass(mobileActiveClass).addClass(globalActiveItemClass);
      }
    });

    /* DESKTOP SPECIFIC */
    $desktopCurrencyToggle.on('click', function toggleCurrency() {
      desktopToggle(this);
    });

    $desktopCurrencyItem.on('click', function toggleCurrencyDesktop() {
      if (!$(this).hasClass(desktopActiveItemClass)) {
        $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
        $(this).addClass(desktopActiveItemClass).addClass(globalActiveItemClass);
      }
      window.OptionsDropdown.toggle();
    });

    /* GLOBAL */
    $currencyItem.on('click', function updatePrices() {
      const currencyCode = $(this).data('currency');

      $desktopCurrencyDisplayText.text(currencyCode);

      if ($(this).hasClass('desktop-currency-item')) {
        $mobileItem.removeClass(mobileActiveClass).removeClass(globalActiveItemClass);
        $mobileItem.each(function setActiveMobileClass() {
          setActiveClass($(this), mobileActiveClass, globalActiveItemClass, currencyCode);
        });

        desktopToggle($(this).parents('.js-desktop-currency-wrapper').find('.js-desktop-currency-toggle')[0]);
      } else {
        $desktopCurrencyItem.removeClass(desktopActiveItemClass).removeClass(globalActiveItemClass);
        $desktopCurrencyItem.each(function setActiveDesktopClass() {
          setActiveClass($(this), desktopActiveItemClass, globalActiveItemClass, currencyCode);
        });

        $mobileCurrencyList.slideToggle();
        arrowToggle($(this).parents('.mobile-nav-items').find('.js-mobile-currency-toggle')[0]);
      }

      setCurrency($(this).data('currency'));
    });
  };

  const windowBind = () => {
    $window.on('load', () => {
      $currencyItem.each(function setCurrencyOnLoad() {
        const currency = $(this).data('currency');
        const keys = Object.keys(window.Geolizr.currencies);
        for (let i = 0; i < keys.length; i++) {
          if (window.Geolizr.currencies[keys[i]].toLowerCase() === currency.toLowerCase()) {
            $(this).attr('data-country', keys[i]);
            break;
          }
        }
        if (currency === 'USD') {
          $(this).attr('data-country', 'US');
        }
      });

      removeCurrencyWidget();
      initialCurrencyView();
    });
  };

  const bindUIActions = (options) => {
    clickBind();
    windowBind();

    if (options.displayCurrency) {
      if (window.Geolizr && window.GeolizrAPI) {
        window.GeolizrAPI.addEventListener('currency.change', () => {
          $('[data-geolizr-price]').css('opacity', '1');
        });
      }
    }
  };

  const init = (options) => {
    cacheDom();
    bindUIActions(options);
  };

  CurrencyWidget.init = init;
})(window.CurrencyWidget = window.CurrencyWidget || {}, jQuery);
